import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IsLoading, LoadingWrapper } from 'src/app/shared/decorators';
import { Observable } from 'rxjs';
import { SaveSearchResponse } from 'src/app/shared/dto';
import { SaveSearchApiService } from "src/app/shared/services/api";
import { ReportingDashboardService } from '../../services';

const GET_RECENT_SAVED_SEARCH_LOADING_TAG: string = 'get-recent-saved-search';

@Component({
    selector: 'app-saved-searches-card-container',
    templateUrl: './saved-searches-card-container.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SavedSearchesCardContainerComponent implements OnInit {
    @IsLoading(GET_RECENT_SAVED_SEARCH_LOADING_TAG) readonly isRecentSavedSearchLoading$: Observable<boolean>;

    savedSearchesData$: Observable<SaveSearchResponse>;

    constructor(
        private readonly saveSearchApiService: SaveSearchApiService,
        private readonly reportingDashboardService: ReportingDashboardService,
    ) { }

    ngOnInit(): void {
        this.savedSearchesData$ = this.getSavedSearchList();
    }

    onRecentSavedSearchEvent(event): void {
        this.reportingDashboardService.onRecentSavedSerch(event);
    }

    @LoadingWrapper(GET_RECENT_SAVED_SEARCH_LOADING_TAG)
    private getSavedSearchList(): Observable<SaveSearchResponse> {
        const saveSearchParams = {
            page: 1,
            sortBy: 'date',
            sortDirection: 'desc',
            isPublic: true,
            name: ''
        }
        return this.saveSearchApiService.getSavedSearchList(saveSearchParams);
    }
}
